export default __webpack_public_path__ + "static/media/brickwall.0c73ac56.svg";